
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Plus } from 'lucide-react';

interface FamilyMember {
  id: string;
  name: string;
  relationship: string;
  score: number;
  avatar: string;
}

interface FamilyMemberSelectorProps {
  familyMembers: FamilyMember[];
  selectedMember: string;
  onMemberSelection: (memberId: string) => void;
}

export const FamilyMemberSelector = ({ 
  familyMembers, 
  selectedMember, 
  onMemberSelection 
}: FamilyMemberSelectorProps) => {
  const getScoreColor = (score: number) => {
    if (score >= 850) return '#22C55E'; // green-500
    if (score >= 700) return '#84CC16'; // lime-500
    if (score >= 550) return '#EAB308'; // yellow-500
    if (score >= 400) return '#F97316'; // orange-500
    return '#EF4444'; // red-500
  };

  return (
    <div className="mb-6">
      <div className="flex items-center space-x-2 overflow-x-auto pb-2">
        {familyMembers.map((member) => (
          <Button
            key={member.id}
            variant={selectedMember === member.id ? "default" : "outline"}
            size="sm"
            onClick={() => onMemberSelection(member.id)}
            className="flex items-center space-x-2 whitespace-nowrap"
          >
            <span>{member.avatar}</span>
            <span>{member.name}</span>
            <Badge 
              variant="secondary" 
              className="ml-1"
              style={{ 
                backgroundColor: getScoreColor(member.score) + '20',
                color: getScoreColor(member.score),
                borderColor: getScoreColor(member.score) + '40'
              }}
            >
              {member.score}
            </Badge>
          </Button>
        ))}
        <Button variant="outline" size="sm" className="flex items-center space-x-1">
          <Plus className="h-4 w-4" />
          <span>Add Member</span>
        </Button>
      </div>
    </div>
  );
};
